import { parseUrl } from "./util";

export const getBase64 = (file, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => {
        const base64 = reader.result;
        const name = file.name;
        const size = file.size;
        const type = base64.split(",")[0].split(";")[0].split(":")[1] || file.type;
        const blob = base64.split(",")[1] || [];
        callback({ blob, type, name, size: size });
    });
    reader.readAsDataURL(file);
};

export const download = ({ file }) => {
    const { saveAs } = require("file-saver");
    if (file.url) {
        saveAs(parseUrl(file.url), file.name);
    } else if (file.blob && file.type) {
        saveAs(`data:${file.type};base64,${file.blob}`, file.name);
    }
};

export const niceBytes = (byte) => {
    const units = ["bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    let l = 0,
        n = parseInt(byte, 10) || 0;
    while (n >= 1024 && ++l) {
        n = n / 1024;
    }
    return n.toFixed(n < 10 && l > 0 ? 1 : 0) + " " + units[l];
};

export const base64ToFileModel = ({ name, base64 }) => {
    const fileName = name || "untitle";
    const type = base64.split(',')[0].split(';')[0].split(':')[1];
    const blob = base64.split(',')[1];
    const size = blob?.length || 0;
    return { blob, type, name: fileName, size: size };
}

export const urlToFileModel = ({ file, callback, options }) => {
    const url = parseUrl(file.url);
    fetch(url).then(res => res.blob().then(blob => getBase64(blob, callback, options)));
}